const CircleExclamationIcon = ({ className }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="36" height="36" rx="18" fill="#F3F4F6" />
      <path
        d="M17.5757 17.7927C17.5178 17.7918 17.4509 17.7918 17.3683 17.7918C17.0231 17.7918 16.7433 17.5119 16.7433 17.1668C16.7433 16.8216 17.0231 16.5418 17.3683 16.5418L17.397 16.5418C17.568 16.5417 17.7528 16.5416 17.9088 16.5626C18.0916 16.5872 18.3251 16.6504 18.5216 16.8469C18.7181 17.0434 18.7813 17.2769 18.8058 17.4596C18.8268 17.6156 18.8267 17.8005 18.8267 17.9714L18.8267 22.1668C18.8267 22.5119 18.5468 22.7918 18.2017 22.7918C17.8565 22.7918 17.5767 22.5119 17.5767 22.1668V18.0001C17.5767 17.9175 17.5766 17.8506 17.5757 17.7927Z"
        fill="#7B828C"
      />
      <path
        d="M17.9933 13.8334C17.5331 13.8334 17.16 14.2065 17.16 14.6667C17.16 15.127 17.5331 15.5001 17.9933 15.5001H18.0008C18.4611 15.5001 18.8341 15.127 18.8341 14.6667C18.8341 14.2065 18.4611 13.8334 18.0008 13.8334H17.9933Z"
        fill="#7B828C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0415 18.0001C9.0415 22.9476 13.0523 26.9584 17.9998 26.9584C22.9474 26.9584 26.9582 22.9476 26.9582 18.0001C26.9582 13.0525 22.9474 9.04175 17.9998 9.04175C13.0523 9.04175 9.0415 13.0525 9.0415 18.0001ZM17.9998 25.7084C13.7426 25.7084 10.2915 22.2573 10.2915 18.0001C10.2915 13.7429 13.7426 10.2917 17.9998 10.2917C22.257 10.2917 25.7082 13.7429 25.7082 18.0001C25.7082 22.2573 22.257 25.7084 17.9998 25.7084Z"
        fill="#7B828C"
      />
    </svg>
  );
};

export default CircleExclamationIcon;
